/* eslint-disable no-undef */

export type TooltipProps = {
  text: string;
  children: JSX.Element;
  _className?: string;
  _position?: string;
  position?: string;
  disabled?: boolean;
};
function Tooltip(props: TooltipProps) {
  const { text, children, _className, disabled = false } = props;
  const positionClasses = props.position || "bottom-0";
  return (
    <div className="relative inline-flex group align-middle">
      {children}
      <div
        style={{ zIndex: 100, position: "absolute" }}
        className={`absolute ${positionClasses} whitespace-normal z-50 overflow-x-visible text-wrap
          flex-col items-center hidden mb-6 ${
           disabled ? "" : "group-hover:flex"
         }`}
      >
        <div
          className={`relative p-2 text-justify text-sm text-black shadow-lg bg-white rounded-md border border-gray-200 ${_className}`}
        >
          {text}
        </div>
      </div>
    </div>
  );
}

export default Tooltip;
